import { db, functions } from '@/firebase'
import { redondeo, } from "@/utils/utils.js";
import firebase from 'firebase'

import moment from 'moment';
var XLSX = require('xlsx');

export default {
    exportarTrimestre({ rootState }, trimestre) {
        console.log(trimestre);
        return Promise.all(rootState.restaurantes.restaurantesArray.map(r => {
            console.log(r);
            return db.collection('restaurantes')
                .doc(r.id).collection('contable')
                .doc('apuntes')
                .collection('listado')
                .where('moment', '>=', trimestre[0].unix())
                .where('moment', '<=', trimestre[1].unix())
                .get()
                .then((r) => {
                    console.log(r.size);
                    return r.docs.map(c => {
                        return {
                            id: c.id,
                            ...c.data()
                        }
                    })
                })
                .catch(e => console.log(e))
        }))
            .then((r) => {
                console.log(r);
                console.log()
                let contable = r.flat().sort((a, b) => a.moment - b.moment);
                console.log(contable);
                const workbook = XLSX.utils.book_new();


                var ws = XLSX.utils.aoa_to_sheet([])
                XLSX.utils.sheet_add_aoa(ws, [
                    ['FACTURA', 'PEDIDO', 'EMISION', 'BASE IMPONIBLE', 'IMPUESTOS', 'TOTAL', 'FORMA PAGO']
                ], { origin: 'A1' });
                var wscols = [
                    { wch: 20 },
                    { wch: 34 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 20 },
                ];

                ws['!cols'] = wscols;

                XLSX.utils.sheet_add_aoa(ws,
                    contable.map(c => {
                        return [c.codigoFactura, c.restaurante, moment.unix(c.moment).format('YYYY-MM-DD HH:mm'), redondeo(c.baseImponiblePago), redondeo(c.impuestosTotalesPago), redondeo(c.pagado), c.formaPago]
                    }), { origin: "A3" })


                XLSX.utils.book_append_sheet(workbook, ws, trimestre[2].toUpperCase())

                const filename = rootState.app.negocioGest;
                XLSX.writeFile(workbook, trimestre[2] + '.xlsx');

            })

    },
    buscarPago({ }, pago) {
        console.log(pago);
        let serie = pago[1];
        let rest = pago.substr(2, 3);
        let fact = pago.substr(5);
        return db.collection('restaurantes')
            .where('codigoRest', '==', rest)
            .get()
            .then(r => {
                if (r.size == 0) return Promise.reject("fallo en el restaurante")
                return { ...r.docs[0].data(), id: r.docs[0].id }
            })
            .then(restObj => {
                return db.collection('restaurantes')
                    .doc(restObj.id).collection('contable')
                    .doc('apuntes').collection('listado')
                    .where('codigoFactura', '==', pago)
                    .get()
                    .then((r) => {
                        console.log(r.size)
                        if (r.size > 0) {
                            let pago = r.docs[0].data();
                            console.log(pago);
                            return pago;
                        }
                    })
                    .catch(e => console.log(e))
            })

    },
    arreglarContaiblidad({ rootState }) {
        return Promise.all(rootState.restaurantes.restaurantesArray.map(r => {
            console.log(r);
            return db.collection('restaurantes')
                .doc(r.id).collection('contable')
                .doc('apuntes')
                .collection('listado')
                .get()
                .then((r) => {
                    return r.docs.map(c => {
                        return {
                            id: c.id,
                            ...c.data()
                        }
                    })
                })
                .catch(e => console.log(e))
        }))
            .then(async (r) => {
                let contableArreglar = r.flat().filter(c => Math.abs(redondeo(c.baseImponiblePago) + redondeo(c.impuestosTotalesPago) - c.pagado) > 0.01)
                    .map(c => { return { ...c, diferencia: c.baseImponiblePago + c.impuestosTotalesPago - c.pagado } }).sort((a, b) => a.moment - b.moment);
                for (let contableC of contableArreglar) {
                    // let pedidoObj = (await db.collection('pedidos').doc(contableArreglar[0].pedido).get()).data()
                    // console.log(contableC);
                    let serie = contableC.codigoFactura[1];
                    let rest = contableC.codigoFactura.substr(2, 3);
                    let fact = contableC.codigoFactura.substr(5);
                    if (serie == 'T') {

                        let impuesto = 1 + contableC.impuestosDesglosePago[0].impuesto
                        console.log(contableC.impuestosDesglosePago[0].impuesto)
                        let baseImponiblePago = redondeo(contableC.pagado / impuesto)
                        let impuestosTotalesPago = redondeo(contableC.pagado - baseImponiblePago);

                        let contableArreglarObj = {
                            "impuestosDesglosePago": [
                                {
                                    "impuesto": contableC.impuestosDesglosePago[0].impuesto,
                                    "cantidad": impuestosTotalesPago
                                }
                            ],

                            "baseImponiblePago": baseImponiblePago,
                            "pagado": contableC.pagado,
                            "impuestosTotalesPago": impuestosTotalesPago,
                            "productos": [],
                            "adicional": 'correción cobrado desglose.'
                        }
                        console.log(contableArreglarObj);
                        await db.collection('restaurantes')
                            .doc(contableC.restaurante).collection('contable')
                            .doc('apuntes')
                            .collection('listado').doc(contableC.id).set(contableArreglarObj, { merge: true })

                    }
                    else if (serie == 'N') { //falta recargo
                        let recargo = Math.abs(contableC.diferencia)
                        let impuesto = 1 + contableC.impuestosDesglosePago[0].impuesto
                        console.log(contableC.impuestosDesglosePago[0].impuesto)
                        let baseImponiblePago = redondeo(contableC.pagado / impuesto)
                        let impuestosTotalesPago = redondeo(contableC.pagado - baseImponiblePago);

                        let contableArreglarObj = {
                            "impuestosDesglosePago": [
                                {
                                    "impuesto": contableC.impuestosDesglosePago[0].impuesto,
                                    "cantidad": impuestosTotalesPago
                                }
                            ],

                            "baseImponiblePago": baseImponiblePago,
                            "pagado": contableC.pagado,
                            "impuestosTotalesPago": impuestosTotalesPago,
                            "productos": [...contableC.productos, {
                                nombre: 'recargo',
                                impuesto: contableC.impuestosDesglosePago[0].impuesto,
                                precioProductoTotalUnitario: recargo,
                                cantidad: 1

                            }],
                            "adicional": 'correción recargo.'
                        }
                        console.log(contableArreglarObj);
                        await db.collection('restaurantes')
                            .doc(contableC.restaurante).collection('contable')
                            .doc('apuntes')
                            .collection('listado').doc(contableC.id).set(contableArreglarObj, { merge: true })

                    } else if (serie == 'A') { //abono
                        let impuesto = 1.1
                        let baseImponiblePago = redondeo(contableC.pagado / impuesto)
                        let impuestosTotalesPago = redondeo(contableC.pagado - baseImponiblePago);

                        let contableArreglarObj = {
                            "impuestosDesglosePago": [
                                {
                                    "impuesto": impuesto,
                                    "cantidad": impuestosTotalesPago
                                }
                            ],

                            "baseImponiblePago": baseImponiblePago,
                            "pagado": contableC.pagado,
                            "impuestosTotalesPago": impuestosTotalesPago,
                            "productos": [],
                            "adicional": 'correción cobrado desglose.'
                        }
                        console.log(contableArreglarObj);
                        await db.collection('restaurantes')
                            .doc(contableC.restaurante).collection('contable')
                            .doc('apuntes')
                            .collection('listado').doc(contableC.id).set(contableArreglarObj, { merge: true })
                    }
                }
            })
    },
    crearSistemaContable({ rootState }, rest) {
        return db.collection('restaurantes').doc(rest).collection('contable').doc('contadores').set({
            //codigoRestaurante: codigoRestaurante,
            numeroContableTpv: 1,
            numeroContableOnline: 1,
            numeroContableAbono: 1,
        })
    },
    getNumerosContables({ rootState, commit, dispatch }, rest) {
        return db.collection('restaurantes').doc(rest).collection('contable').doc('contadores')
            .get().then(async (r) => {
                if (r.exists) {
                    console.log(r.data())
                    commit('SET_NUMEROS_CONTABLES', { rest: rest, datos: r.data() })
                    return r.data();

                } else {
                    console.log("crear sistema contable");
                    await dispatch('crearSistemaContable', rest);
                    console.log("creado")
                    return dispatch('getNumerosContables')
                }
            })
    },
    incrementarContadores({ rootState, dispatch }, { serie, rest }) {
        let grabar = {};
        var ref = db.collection('restaurantes').doc(rest).collection('contable').doc('contadores')
        switch (serie) {
            case 'tpv':
                grabar.numeroContableTpv = firebase.firestore.FieldValue.increment(1);
                break;
            case 'online':
                grabar.numeroContableOnline = firebase.firestore.FieldValue.increment(1);
                break;
            case 'abono':
                grabar.numeroContableAbono = firebase.firestore.FieldValue.increment(1);
                break;
        }

        return ref.set(grabar, { merge: true })
            .then(() => dispatch('getNumerosContables', rest))
            .catch(e => console.log(e))
    },
    async contabilizarPedidoAntiguo({ rootState, dispatch }, pedido) {
        let rest = pedido.negocio + '-' + pedido.restaurante;
        let f = rootState.restaurantes.restaurantesArray.find(r => r.id === rest);
        let contador = await dispatch('getNumerosContables', rest);
        console.log(contador);

        if (f) {
            if (!Array.isArray(pedido.cobradoDesglose)) {
                pedido.cobradoDesglose = [
                    {
                        formaPago: pedido.forma_pago,
                        pagado: parseFloat(pedido.precioTotal)
                    }
                ]
            }
            let desgloseAux = pedido.cobradoDesglose.map(p => {
                var baseImponiblePago = 0;
                var impuestosDesglosePago = [];
                var impuestosTotalesPago = 0;



                return {
                    ...p,
                    productos: (!!p.productos ? p.productos : pedido.productos).filter((p) => p.cantidad > 0)
                        .map((p) => {
                            let precioProductoTotalUnitario = !!p.precioProductoTotalUnitario
                                ? p.precioProductoTotalUnitario
                                : !!p.precioProductoTotal
                                    ? p.precioProductoTotal : p.precio
                            let baseImponible = redondeo(
                                (precioProductoTotalUnitario * p.cantidad) / (p.impuesto + 1)
                            );
                            let impuestosCantidad =
                                redondeo(precioProductoTotalUnitario * p.cantidad - baseImponible);
                            baseImponiblePago += baseImponible;
                            impuestosTotalesPago += impuestosCantidad;
                            let fI = impuestosDesglosePago.findIndex(
                                (i) => i.impuesto === p.impuesto
                            );
                            if (fI > -1) {
                                impuestosDesglosePago[fI].cantidad += impuestosCantidad;
                            } else {
                                impuestosDesglosePago.push({
                                    impuesto: p.impuesto,
                                    cantidad: impuestosCantidad,
                                });
                            }


                            return {
                                id: p.id,
                                cantidad: p.cantidad,
                                precioProductoTotalUnitario: precioProductoTotalUnitario,
                                //precioProductoTotal: p.precioProductoTotal,// este valor es el precio de todos los productos, no de los que se están pagando, que se calcula multiplicando el unitario por la cantidad pagada
                                nombre: p.nombre,
                                opciones: p.opciones,
                                opcionesName: p.opcionesName,
                                opcionesPrecio: p.opcionesPrecio,
                                impuesto: p.impuesto,
                                baseImponible: baseImponible,
                                impuestoCantidad: impuestosCantidad,
                                // impuestoCantidad: p.impuestoCantidad, este valor es el precio de todos los productos, no de los que se están pagando, que se calcula multiplicando el unitario por la cantidad pagada
                            };
                        }),
                    baseImponiblePago: redondeo(baseImponiblePago),
                    impuestosDesglosePago: impuestosDesglosePago,
                    impuestosTotalesPago: redondeo(impuestosTotalesPago),
                    moment: pedido.cobrado,
                }
            })
            //base imponible e impuestos en el pago

            console.log(desgloseAux)
            let desgloseRecorrer = [...desgloseAux]
            await Promise.all(desgloseRecorrer.map(async (d, i) => {
                let codigoFactura = await dispatch("crearApunteContable", {
                    pedido: pedido,
                    datos: d,
                    restaurante: f
                });
                desgloseAux[i].codigoFactura = codigoFactura
                console.log("fin " + i)
            }))

            await db.collection('pedidos').doc(pedido.id).set({
                cobradoDesglose: desgloseAux
            }, { merge: true })
        }


    },
    async crearApunteContable({ rootState, state, dispatch }, { pedido, datos, restaurante }) {
        console.log(datos);
        console.log(restaurante);
        let canal = pedido.canalVenta;

        switch (pedido.forma_pago) {
            case 'tarjeta_online':
                datos.serie = 'online';
                break;
            default:
                datos.serie = 'tpv';
                break;

        }
        if (!!pedido.abonoPedidoOriginal) { //es abono
            datos.serie = 'abono'
        }
        let codigoRestaurante = restaurante && restaurante.codigoRest
            ? restaurante.codigoRest
            : '001'
        console.log(codigoRestaurante);
        var numeroContable;
        let serieCodigo;
        switch (datos.serie) {
            case 'tpv':
                serieCodigo = 'T';
                numeroContable = state.numerosContables[restaurante.id].numeroContableTpv
                break;
            case 'online':
                serieCodigo = 'N';

                numeroContable = state.numerosContables[restaurante.id].numeroContableOnline
                break;
            case 'abono':
                serieCodigo = 'A';
                numeroContable = state.numerosContables[restaurante.id].numeroContableAbono
                break;
        }
        //let codigoFactura = 'FN' + codigoRestaurante + '-' + numeroOnline.toString().padStart(10, '0');
        let codigoFactura = 'F' + serieCodigo + codigoRestaurante + numeroContable.toString().padStart(10, '0');;
        console.log(codigoFactura)
        console.log(datos);
        await dispatch('incrementarContadores', { serie: datos.serie, rest: restaurante.id })


        // Los impuestos y base imponible vienen desde 
        // datos.productos = datos.productos.map(p => {
        //     let baseImponible = redondeo(p.precioProductoTotalUnitario * p.cantidad / (p.impuesto + 1)); //dividir entre 1.1, 1,21, 1,04 ...
        //     return {
        //         ...p,
        //         impuestoCantidad: redondeo((p.precioProductoTotalUnitario * p.cantidad) - baseImponible),
        //         baseImponible: baseImponible

        //     }
        // })
        // datos.baseImponible = redondeo(datos.productos.reduce((accumulator, a) => accumulator + a.baseImponible, 0))
        // datos.impuestosTotal = redondeo(datos.pagado - datos.baseImponible)

        datos.codigoFactura = codigoFactura
        datos.restaurante = restaurante.id
        datos.negocio = pedido.negocio
        datos.pedido = pedido.id
        console.log(datos);
        //return;
        return db.collection('restaurantes')
            .doc(restaurante.id).collection('contable')
            .doc('apuntes').collection('listado')
            .doc(codigoFactura + '-' + moment().unix()).set(datos)
            .then(() => codigoFactura)
            .catch(e => console.log(e))
    },
    generarFactura({ }, payload) {
        console.log(payload)
        var fact = functions.httpsCallable('httpTpvGenerarFactura');
        return fact(payload).then(r => {

        })
    },
}